<div class="punch-loop-container">
  <video
    playsinline
    muted
    autoplay
    preload="auto"
    class="punch-loop noselect"
    loop
  >
    <source
      type="video/mp4"
      src="https://r2.bitframes.io/assets/video/punch-loop.mp4"
    />
  </video>
</div>

<style>
  .punch-loop {
    user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    width: 100%;
    aspect-ratio: var(--aspect);
    height: auto;
  }
  .punch-loop {
    transform: scale(1.05) translateZ(0);
  }
  .punch-loop-container {
    background-color: black;
    border-radius: 50px;
    max-width: 500px;
    --aspect: 932/692;
    aspect-ratio: var(--aspect);
  }
  .punch-loop-container {
    margin-top: 20px;
    margin-bottom: 10px;
    display: flex;
    will-change: transform;
    transform: translateZ(0);
    justify-content: center;
    align-items: center;
    overflow: hidden;
    width: 100%;
  }
</style>
